module.exports = "<app-header></app-header>\n\n<div class=\"splitter\">\n  <split direction=\"horizontal\">\n    <split-area size=\"50\">\n      <app-left-pane></app-left-pane>\n    </split-area>\n    <split-area size=\"50\">\n      <app-console-pane></app-console-pane>\n    </split-area>\n  </split>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main